import { useState } from "react";
import { Reveal, Eyebrow } from "../components/motion";
import { ProductCard } from "../components/ProductCard";
import { useProducts } from "../hooks/useProducts";

const FILTERS = [
  { key: "all", label: "Tutti" },
  { key: "trattamento", label: "Trattamento" },
  { key: "scrub", label: "Scrub" },
  { key: "fibra", label: "Federa in Seta" },
  { key: "accessori", label: "Accessori" },
  { key: "kit", label: "Percorsi" },
];

export default function Shop() {
  const { products, loading } = useProducts();
  const [filter, setFilter] = useState("all");
  const visible = products.filter((p) => filter === "all" || p.category === filter);

  return (
    <main data-testid="shop-page" className="py-14 sm:py-20">
      <div className="max-w-7xl mx-auto px-6">
        <Reveal className="max-w-2xl">
          <Eyebrow>Lo shop</Eyebrow>
          <h1 className="mt-4 font-serif text-4xl sm:text-5xl text-plum tracking-tight">
            Tutti i prodotti
          </h1>
          <p className="mt-4 text-base sm:text-lg text-plum/60 leading-relaxed">
            Formule botaniche per il cuoio capelluto e la bellezza della fibra. Scegli ciò di cui i tuoi capelli hanno bisogno.
          </p>
        </Reveal>

        <div className="mt-10 flex flex-wrap gap-2" data-testid="shop-filters">
          {FILTERS.map((f) => (
            <button
              key={f.key}
              data-testid={`filter-${f.key}`}
              onClick={() => setFilter(f.key)}
              className={`px-5 py-2.5 rounded-full text-xs font-bold uppercase tracking-[0.12em] transition-all duration-300 ${
                filter === f.key
                  ? "bg-lilac text-white shadow-[0_8px_24px_-8px_rgba(139,92,246,0.6)]"
                  : "bg-mist text-plum/70 hover:bg-lilac-soft hover:text-plum"
              }`}
            >
              {f.label}
            </button>
          ))}
        </div>

        {loading ? (
          <p className="mt-16 text-center text-plum/50">Caricamento prodotti...</p>
        ) : (
          <div className="mt-10 grid grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-4 sm:gap-6">
            {visible.map((p, i) => (
              <ProductCard key={p.slug} product={p} index={i} />
            ))}
          </div>
        )}
      </div>
    </main>
  );
}
